export default "__VITE_ASSET__CBdZf4DR__"